exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ChangePasswordForm-btnBig-t5SVG {\n\tpadding: 13px 21px !important;\n\twidth: 100%;\n}\n\n.ChangePasswordForm-pwdImage-MtSvL {\n\tposition: absolute;\n\ttop: 49px;\n\tright: 20px;\n\tcursor: pointer;\n}\n\n.ChangePasswordForm-root-I6r7E {\n\tborder: 1px solid var(--border-color) !important;\n\tpadding: 30px;\n\tborder-radius: 14px;\n}\n\n.ChangePasswordForm-titleText-fOy1c {\n\tfont-size: 22px;\n\tfont-weight: 600;\n\tmargin: 0px 0px 22px;\n}", ""]);

// exports
exports.locals = {
	"btnBig": "ChangePasswordForm-btnBig-t5SVG",
	"pwdImage": "ChangePasswordForm-pwdImage-MtSvL",
	"root": "ChangePasswordForm-root-I6r7E",
	"titleText": "ChangePasswordForm-titleText-fOy1c"
};